import { findAcknowledgment } from 'helpers/acknowledgments';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import useAcknowledgments from 'services/acknowledgments/useAcknowledgments';
import useFeature from 'services/features/useFeature';
import { AcknowledgmentResource } from 'types/Acknowledgment';

/**
 * Whether a condition's card should mark it sensitive: a sensitive condition the
 * user has not acknowledged for this kit yet. Returns a checker for list rows.
 */
export default function useIsSensitiveUnacknowledged() {
  const { isFeatureEnabled: isSensitiveModalEnabled } = useFeature(
    'sensitive_conditions_reminder_modal',
  );
  const { data: acknowledgments } = useAcknowledgments();
  const { currentTinyAccountId, currentKitId } = useCurrentKitAndTinyAccount();

  return (conditionId: number, sensitive: boolean) =>
    isSensitiveModalEnabled &&
    sensitive &&
    !findAcknowledgment(
      acknowledgments,
      AcknowledgmentResource.CONDITIONS_METRICS,
      `${conditionId}`,
      currentTinyAccountId ?? '',
      currentKitId ?? '',
    );
}
